<template>
    <component
        :is="componentName"
        v-model="formSelect"
        :label="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
        dense
        outlined
        rounded
        :items="selectItems"
        v-bind="$attrs"
        :clearable="typeof $attrs.clearable === 'undefined' ? !!formSelect : $attrs.clearable"
        :error-messages="errorMessage"
        :disabled="isReadonly || $attrs.disabled"
        background-color="#fff"
        append-icon="mdi-chevron-down"
        :chips="$attrs.hasOwnProperty('multiple')"
        v-on="$listeners"
        @change="resetErrorMessage($event)"
    >
        <template #append-outer>
            <slot name="append-outer"></slot>
        </template>

        <template v-if="$scopedSlots.item" #item="slotProps">
            <slot name="item" v-bind="slotProps"></slot>
        </template>
        <template v-if="$scopedSlots.selection" #selection="slotProps">
            <slot name="selection" v-bind="slotProps"></slot>
        </template>
    </component>
</template>

<script>
export default {
    name: 'BSelect',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        selectItems: {
            type: Array,
            required: true,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
        componentName: {
            type: String,
            required: false,
            default: 'v-select',
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },
    computed: {
        formSelect: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
            },
        },
        errorMessage() {
            return _.get(this.$store.state[this.store].errorMessages, this.propertyToMutate);
        },
        isReadonly() {
            if (typeof this.$attrs.readonly !== 'undefined') {
                return this.$attrs.readonly;
            }

            if (this.filters) {
                return false;
            }

            if (this.forceReadonly) {
                return true;
            }

            const propertyToMutate = this.propertyToMutate.toString().split('.').slice(-2).join('.');

            if (!is_writeable(propertyToMutate)) {
                return true;
            }

            return false;
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
    methods: {
        resetErrorMessage() {
            if (this.errorMessage) {
                this.$store.commit(`${this.store}/SET_ERROR_MESSAGE`, {
                    value: [],
                    property: this.propertyToMutate,
                });
            }
        },
    },
};
</script>

<style></style>
